import { z } from "zod";

// ============================================================================
// BASE CALL ATTEMPT SCHEMA (matches backend DbCallAttemptOutput)
// ============================================================================

// To sync with DbCallAttemptOutput in backend/schemas/call-attempt.ts
const BaseCallAttemptSchema = z.object({
  // Primary fields
  id: z.string(),

  // Relations
  sessionId: z.string(),
  attemptNumber: z.number(),

  // Status and outcome
  status: z.string(), // 'initiating' | 'in_progress' | 'completed' | 'failed'
  outcome: z.string().nullable().optional(), // 'completed' | 'no_answer' | 'busy' | 'failed' | 'voicemail' | 'wrong_number' | 'disconnected'

  // Timing
  startedAt: z.string().nullable().optional(),
  endedAt: z.string().nullable().optional(),
  durationSeconds: z.number().nullable().optional(),

  // Call agent integration
  callAgentId: z.string().nullable().optional(),
  callAgentProvider: z.string().nullable().optional(),

  // Call details
  disconnectionReason: z.string().nullable().optional(),
  callCost: z.number().nullable().optional(),

  // Performance metrics
  llmTokenUsage: z.unknown().nullable().optional(),
  latencyMs: z.number().nullable().optional(),

  // Analysis
  callAnalysis: z.unknown().nullable().optional(),

  // Metadata
  metadata: z.record(z.string(), z.unknown()).nullable().optional(),

  // Timestamps
  createdAt: z.string(),
  updatedAt: z.string(),
});

export const CallAttemptSchema = BaseCallAttemptSchema;

export const CallAttemptListItemSchema = BaseCallAttemptSchema.extend({
  sessionStatus: z.string().nullable().optional(),
  patientName: z.string().nullable().optional(),
});

export const CallAttemptListSchema = z.array(CallAttemptListItemSchema);

// ============================================================================
// TYPE EXPORTS
// ============================================================================

export type CallAttempt = z.infer<typeof CallAttemptSchema>;
export type CallAttemptListItem = z.infer<typeof CallAttemptListItemSchema>;
